import { MenuConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';

export const config = {
    id: ActionType.VIP_LINK_TEXT,
};

export const INSERT_TEXT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        style: {
            paddingLeft: 0,
            paddingRight: 0,
            width: 'auto',
        },
    },
];
